import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'wfdss-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit, AfterViewInit {
  confirmationMessage = 'You are about to remove a collaborator. Are you sure?';

  constructor(@Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {    
    if(this.data?.focusOnOk) {
      setTimeout(function() {
        document.getElementById('primaryBtn')?.focus();
      }, 300)      
    }
  }

}
